import React, { useEffect, useState } from "react";
// import NewNavBar from "../../element/NewNavBar";
import NavBar from "../element/NavBar";
import Footer from "../element/Footer";
import NewFooter from "../element/NewFooter";

import JobCard from "../element/JobCard";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BaseApi from "../api/BaseApi";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import NewJobCard from "../element/NewJobCard";
import ApiKey from "../api/ApiKey";
import Header from "../element/Header";

const SearchJobPage = () => {
  const { slug } = useParams();
  // const initialKeyword = sessionStorage.getItem("keywordTitle") || "";
  let keyWord = sessionStorage.getItem("keywordTitle");

  const initialKeyword = keyWord || slug || "";

  const initialCategory = sessionStorage.getItem("catId") || "";
  const [filterItem, setFilterItem] = useState({
    keyword: initialKeyword,
    category_id: initialCategory,
    subcategory_id: "",
    location: "",
    state_id: "",
  });

  const navigate = useNavigate();

  const [searchData, setSearchData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [stateList, setStateList] = useState([]);

  const [categoryData, setCategoryData] = useState([]);
  const [stateData, setStateData] = useState([]);

  const [searchButton, setSearchButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subCatData, setSubCatData] = useState([]);
  // console.log(initialCategory);
  const [t, i18n] = useTranslation("global");
  const [itemSearched, setItemSearched] = useState(false);
  const tokenKey = Cookies.get("tokenClient");

  const getData = async () => {
    try {
      setLoading(true);
      let response;

      console.log("from child");

      if (initialKeyword) {
        // If a keyword is available in the slug, make the API request with the keyword directly.
        response = await axios.post(
          BaseApi + "/job/listing",
          {
            keyword: initialKeyword,
          },
          {
            headers: {
              "Content-Type": "application/json",
              key: ApiKey,
              token: tokenKey,
              // adminid: adminID,
            },
          }
        );
      } else if (initialCategory) {
        fetchJobListingsByCategory();
        response = await axios.post(
          BaseApi + "/job/listing",
          {
            category_id: initialCategory,
          },
          {
            headers: {
              "Content-Type": "application/json",
              key: ApiKey,
              token: tokenKey,
              // adminid: adminID,
            },
          }
        );
      } else {
        // If no keyword is available, fetch all job listings.
        response = await axios.post(BaseApi + "/job/listing", null, {
          headers: {
            "Content-Type": "application/json",
            key: ApiKey,
            token: tokenKey,
            // adminid: adminID,
          },
        });
      }

      setCategoryList(response.data.response.category);
      setCategoryData(response.data.response.jobs);
      setStateList(response.data.response.states);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error fetching list of categories");
    }
  };
  let primaryColor = Cookies.get("primaryColor");
  let secondaryColor = Cookies.get("secondaryColor");
  const mapKey = Cookies.get("mapKey");

  const [hoverColor, setHoverColor] = useState(false);

  const handleMouseEnter = () => {
    setHoverColor(true);
  };

  const handleMouseLeave = () => {
    setHoverColor(false);
  };

  const [clearColor, setClearColor] = useState(false);

  const handleClearMouseEnter = () => {
    setClearColor(true);
  };

  const handleClearMouseLeave = () => {
    setClearColor(false);
  };

  const [hoverPrevColor, setHoverPrevColor] = useState(false);
  const [hoverNextColor, setHoverNextColor] = useState(false);

  const handlePrevEnter = () => {
    setHoverPrevColor(true);
    // console.log(hoverColor)
  };

  const handlePrevLeave = () => {
    setHoverPrevColor(false);
  };
  const handleNextEnter = () => {
    setHoverNextColor(true);
    // console.log(hoverColor)
  };

  const handleNextLeave = () => {
    setHoverNextColor(false);
  };

  useEffect(() => {
    // if(!tokenKey){
    //   navigate("/user/jobseekerlogin");
    // }else{
    getData();
    if (initialCategory) {
      fetchJobListingsByCategory(initialCategory);
    }
    // }
  }, [initialKeyword]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    // Check if the category_id is being changed
    setFilterItem((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
    if (name === "category_id") {
      // Call the API with the selected category_id
      fetchJobListingsByCategory(value);
    }
    if (filterItem.category_id === "Any Category") {
      // Include the category_id in the API request
      setFilterItem({ ...filterItem, category_id: "" }); // Convert to the desired data type if needed
    }
    console.log(filterItem);
  };

  const handleClick = async (e) => {
    e.preventDefault();
    if (
      filterItem.keyword === "" &&
      filterItem.category_id === "" &&
      filterItem.location === "" &&
      filterItem.state_id === ""
    ) {
      return;
    }
    sessionStorage.setItem("jobSearched", "1");
    setSearchButton(true);
    setLoading(true);
    console.log(filterItem);
    try {
      const response = await axios.post(BaseApi + "/job/listing", filterItem, {
        headers: {
          "Content-Type": "application/json",
          key: ApiKey,
          token: tokenKey,
          // adminid: adminID,
        },
      });
      setSearchData(response.data.response.jobs);
      setLoading(false);
      console.log("Search filter data sent successfully");
    } catch (error) {
      setLoading(false);
      console.log("Couldn't send the search filter data!");
    }
  };

  const fetchJobListingsByCategory = async (categoryId) => {
    // setLoading(true);
    try {
      const response = await axios.post(
        BaseApi + `/categories/getSubCategory/${categoryId}`
      );
      setSubCatData(response.data.response);
      setLoading(false);
      console.log(subCatData);
    } catch (error) {
      setLoading(false);
      console.log("Couldn't get sub category data at listing page");
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSearchButton(false);
    setSearchData([]);
    setSubCatData([]);
    setFilterItem({
      keyword: "",
      category_id: "",
      subcategory_id: "",
      location: "",
      state_id: "",
    });
  };

  useEffect(() => {
    setTimeout(() => {
      sessionStorage.clear();
    }, 7000);
    window.scrollTo(0, 0);
  }, []);

  // // Pagination state
  // const [currentPage, setCurrentPage] = useState(1);
  // const jobsPerPage = 12;

  // // Get current jobs to display based on pagination
  // const indexOfLastJob = currentPage * jobsPerPage;
  // const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  // const currentJobs = searchButton
  //   ? searchData.slice(indexOfFirstJob, indexOfLastJob)
  //   : categoryData.slice(indexOfFirstJob, indexOfLastJob);

  // // Function to handle pagination page change
  // const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 12;

  // Get current jobs to display based on pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = searchButton
    ? searchData.slice(indexOfFirstJob, indexOfLastJob)
    : categoryData.slice(indexOfFirstJob, indexOfLastJob);

  // Function to handle pagination page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top when page changes
  };
  // Total number of jobs to calculate the number of pages
  const totalJobs = searchButton ? searchData.length : categoryData.length;
  const totalPages = Math.ceil(totalJobs / jobsPerPage);

  const [autocompleteService, setAutocompleteService] = useState(null);
  const [suggestions, setSuggestions] = useState([]);

  // useEffect(() => {
  //   // Load Google Maps AutocompleteService after component mounts
  //   const script = document.createElement("script");
  //   script.src = `https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places`;
  //   script.onload = () => {
  //     setAutocompleteService(
  //       new window.google.maps.places.AutocompleteService()
  //     );
  //     console.log(autocompleteService);
  //   };
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  const handleLocationChange = (e) => {
    const { value } = e.target;
    setSuggestionTaken(false);
    if (value === "") {
      setSuggestionTaken(true);
    }

    setFilterItem((prevFilter) => ({
      ...prevFilter,
      location: value,
    }));

    if (autocompleteService) {
      // Call Google Maps Autocomplete API
      autocompleteService.getPlacePredictions(
        {
          input: value,
          types: ["(cities)"], // Restrict to cities if needed
          componentRestrictions: { country: "au" }, // Restrict to Australia
        },
        (predictions, status) => {
          if (status === "OK" && predictions) {
            setSuggestions(
              predictions.map((prediction) => prediction.description)
            );
          } else {
            setSuggestions([]);
          }
        }
      );
    }

    if (filterItem.location === "") {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    // Load Google Maps AutocompleteService after component mounts
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places`;
    script.onload = () => {
      setAutocompleteService(
        new window.google.maps.places.AutocompleteService()
      );
      console.log("Autocomplete service initialized");
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [mapKey]);

  // const handleLocationChange = (e) => {
  //   const { value } = e.target;
  //   setSuggestionTaken(false);
  //   const firstWord = value.split(" ")[0]; // Extract the first word

  //   if (value === "") {
  //     setSuggestionTaken(true);
  //   }

  //   setFilterItem((prevFilter) => ({
  //     ...prevFilter,
  //     location: firstWord,
  //   }));

  //   if (autocompleteService) {
  //     // Call Google Maps Autocomplete API
  //     autocompleteService.getPlacePredictions(
  //       {
  //         input: value,
  //         types: ["(cities)"], // Restrict to cities if needed
  //         componentRestrictions: { country: "au" }, // Restrict to Australia
  //       },
  //       (predictions, status) => {
  //         if (status === "OK" && predictions) {
  //           setSuggestions(
  //             predictions.map((prediction) => prediction.description)
  //           );
  //         } else {
  //           setSuggestions([]);
  //         }
  //       }
  //     );
  //   }

  //   if (filterItem.location === "") {
  //     setSuggestions([]);
  //   }
  // };

  const [suggestionTaken, setSuggestionTaken] = useState(false);

  const handleSuggestionClick = (suggestion) => {
    // Update the input value with the clicked suggestion
    handleLocationChange({ target: { name: "location", value: suggestion } });

    setSuggestionTaken(true);
    // Clear the suggestions
    setSuggestions([]);
    console.log(filterItem);
  };

  return (
    <>
      {/* <NavBar /> */}
      <Header />
      {loading ? (
        <div className="loader-container"></div>
      ) : (
        <>
          <div className="container">
            <ol class="breadcumbs">
              <li>
                <Link to="" title="HOME">
                  HOME
                </Link>
              </li>

              <li>LGBTI Jobs</li>
            </ol>
          </div>
          <div className="sectionJobListing">
            <div className="container">
              <div className="row">
                <div className="col-md-3 col-sm-12 ">
                  <form id="searchBlock">
                    <h2>Quick Search</h2>
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={filterItem.keyword}
                        name="keyword"
                        placeholder={t("searchJobPage.keyword")}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="form-group categorySelect mb-3">
                      <select
                        className="form-select text-muted h-0"
                        aria-label="Default select example"
                        value={filterItem.category_id}
                        name="category_id"
                        onChange={handleChange}
                      >
                        <option value={""}>
                          {t("searchJobPage.anyCategory")}
                        </option>
                        {categoryList.map((i, id) => {
                          return (
                            <option key={i.id} value={i.id}>
                              {i.name}
                            </option>
                          );
                        })}
                      </select>
                    </div> */}
                    

                    <div className="form-group categorySelect mb-3">
                      <select
                        className="form-select text-muted h-0"
                        aria-label="Default select example"
                        value={filterItem.state_id}
                        name="state_id"
                        onChange={handleChange}
                      >
                        <option value={""}>
                          {/* {t("searchJobPage.anyCategory")} */}
                          Choose State
                        </option>
                        {stateList.map((i, id) => {
                          return (
                            <option key={i.state_id} value={i.state_id}>
                              {i.state_id}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="form-group mb-3 locationBoxSearchpage">
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder={t("searchJobPage.enterLocation")}
                        name="location"
                        value={filterItem.location}
                        onChange={handleLocationChange}
                      />
                      {suggestions.length > 0 && (
                        <div
                          className="suggestionsSmall"
                          style={{ display: suggestionTaken ? "none" : "" }}
                        >
                          <ul className="locationDropdown">
                            {suggestions.map((suggestion, index) => (
                              <div key={index} className="suggestion-item">
                                <li
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  }
                                >
                                  <div className="eachLocation">
                                    <div className="locationIcon">
                                      <LocationOnIcon fontSize="small" />
                                    </div>{" "}
                                    <div className="locationSuggestion">
                                      {suggestion}
                                    </div>
                                  </div>
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <button
                      type="submit"
                      class="btn btn-primary"
                      onClick={handleClick}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <i class="fa fa-search"></i> SEARCH
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary btn-clear"
                      onClick={handleReset}
                      style={{
                        backgroundColor: `${
                          secondaryColor &&
                          (clearColor ? secondaryColor : primaryColor)
                        }`,
                      }}
                      onMouseEnter={handleClearMouseEnter}
                      onMouseLeave={handleClearMouseLeave}
                    >
                      {/* {t("searchJobPage.findJobs")} */}
                      {t("searchJobPage.clear")}
                    </button>
                  </form>
                </div>
                <div className="col-md-9 col-sm-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="record-count">
                        <p>
                          <strong>{totalJobs}</strong> record(s) have been
                          found.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 text-right paginationpart">
                      {/* <select className="">
                        <option value="">1/10</option>
                        <option value="">2/10</option>
                        <option value="">3/10</option>
                        <option value="">4/10</option>
                        <option value="">5/10</option>
                      </select>

                      <i class="fa fa-chevron-circle-right cursor-pointer"></i> */}

                      <Link
                        className="btn btn-default"
                        onClick={() => handlePageChange(currentPage - 1)}
                        style={{
                          pointerEvents: currentPage === 1 ? "none" : "auto",
                        }}
                      >
                        <i className="fa fa-chevron-circle-left"></i>
                      </Link>
                      <select
                        value={currentPage}
                        onChange={(e) =>
                          handlePageChange(Number(e.target.value))
                        }
                      >
                        {Array.from({ length: totalPages }, (_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}/{totalPages}
                          </option>
                        ))}
                      </select>
                      <Link
                        className="btn btn-default"
                        onClick={() => handlePageChange(currentPage + 1)}
                        style={{
                          pointerEvents:
                            currentPage === totalPages ? "none" : "auto",
                        }}
                      >
                        <i className="fa fa-chevron-circle-right"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    {searchButton ? (
                      currentJobs.length > 0 ? (
                        currentJobs.map((i) => (
                          <>
                            <div className="col-md-12 col-sm-12">
                              <NewJobCard
                                title={i.title}
                                min_salary={i.min_salary}
                                max_salary={i.max_salary}
                                min_exp={i.min_exp}
                                created={i.created}
                                logo={i.logo}
                                company_name={i.company_name}
                                type={i.type}
                                apply_url={i.apply_url}
                                work_type={i.work_type}
                                slug={i.slug}
                                cat_slug={i.cat_slug}
                                job_city={i.job_city}
                                desc={i.description}
                                is_job_saved={i.is_job_saved}
                                getData={getData}
                              />
                            </div>
                          </>
                        ))
                      ) : (
                        <div className="col-12">
                          <h3 className="text-center">
                            {t("searchJobPage.noJobsTxt1")}{" "}
                          </h3>
                          <h6 className="text-muted text-center mb-5 mt-3">
                            {t("searchJobPage.noJobsTxt2")}
                          </h6>
                        </div>
                      )
                    ) : categoryData.length > 0 ? (
                      currentJobs.map((i) => (
                        <>
                          <div className="col-md-12 col-sm-12">
                            {/* <div className="job-list">
                              <h2>
                                <Link to="">{i.title}</Link>
                                <img
                                  src={i.logo}
                                  alt=""
                                  className="img-fluid logoProfile"
                                />
                              </h2>
                              <h3>
                                <Link to="">{i.company_name}</Link>
                              </h3>
                              <div className="job-list-buttons">
                                <button className="btn btn-primary">
                                  More Info
                                </button>
                                <button className="btn btn-primary btn-apply">
                                  Apply Now
                                </button>
                                <button className="btn btn-primary">
                                  Save Jobs
                                </button>
                                <Link
                                  to=""
                                  className="btn btn-default btn-more-jobs"
                                >
                                  more jobs by
                                  <br />
                                  this advertiser
                                </Link>
                              </div>
                            </div> */}
                            <NewJobCard
                              title={i.title}
                              min_salary={i.min_salary}
                              max_salary={i.max_salary}
                              min_exp={i.min_exp}
                              created={i.created}
                              logo={i.logo}
                              company_name={i.company_name}
                              type={i.type}
                              apply_url={i.apply_url}
                              work_type={i.work_type}
                              slug={i.slug}
                              cat_slug={i.cat_slug}
                              job_city={i.job_city}
                              desc={i.description}
                              is_job_saved={i.is_job_saved}
                              getData={getData}
                            />
                          </div>
                        </>
                        // <div className="col-md-6 col-lg-4">
                        //   <JobCard
                        //     title={i.title}
                        //     min_salary={i.min_salary}
                        //     max_salary={i.max_salary}
                        //     min_exp={i.min_exp}
                        //     created={i.created}
                        //     logo={i.logo}
                        //     company_name={i.company_name}
                        //     work_type={i.work_type}
                        //     slug={i.slug}
                        //     cat_slug={i.cat_slug}
                        //     job_city={i.job_city}
                        //     desc={i.description}
                        //   />
                        // </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <h3 className="text-center">
                          {t("searchJobPage.noJobsTxt1")}{" "}
                        </h3>
                        <h6 className="text-muted text-center mb-5 mt-3">
                          {t("searchJobPage.noJobsTxt2")}{" "}
                        </h6>
                      </div>
                    )}

                    {/* <div className="col-md-12 col-sm-12">
                      <div className="job-list">
                        <h2>
                          <Link to="">
                            Floor Manager - Come host with us at Opera Bar
                          </Link>
                          <img
                            src="./Images/swinburne-logo.png"
                            alt=""
                            className="img-fluid logoProfile"
                          />
                        </h2>
                        <h3>
                          <Link to="">Solotel</Link>
                        </h3>
                        <div className="job-list-buttons">
                          <button className="btn btn-primary">More Info</button>
                          <button className="btn btn-primary btn-apply">
                            Apply Now
                          </button>
                          <button className="btn btn-primary">Save Jobs</button>
                          <Link to="" className="btn btn-default btn-more-jobs">
                            more jobs by
                            <br />
                            this advertiser
                          </Link>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <NewFooter />
        </>
      )}
    </>
  );
};

export default SearchJobPage;
